import React, { useState, useEffect } from 'react';
import { Upload, X } from 'lucide-react';
import { LOGO_URL } from '../config/siteConfig';
import { useLanguage } from '../i18n/LanguageContext';

export const PersonalLogo = ({ size = 'large' }) => {
  const { t } = useLanguage();
  const [customLogo, setCustomLogo] = useState(null);
  const [showUpload, setShowUpload] = useState(false);

  useEffect(() => {
    // Load custom logo from localStorage
    const saved = localStorage.getItem('petechtor_personal_logo');
    if (saved) {
      setCustomLogo(saved);
    }
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const imageUrl = event.target.result;
        setCustomLogo(imageUrl);
        localStorage.setItem('petechtor_personal_logo', imageUrl);
        setShowUpload(false);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemove = () => {
    setCustomLogo(null);
    localStorage.removeItem('petechtor_personal_logo');
    setShowUpload(false);
  };

  const sizeClasses = {
    small: 'w-8 h-8',
    medium: 'w-12 h-12',
    large: 'w-20 h-20'
  };

  return (
    <div className="relative inline-block">
      <div className={`${sizeClasses[size]} rounded-full overflow-hidden shadow-xl`}>
        <img 
          src={customLogo || LOGO_URL} 
          alt="Petechtor Logo" 
          className="w-full h-full object-cover object-center"
        />
      </div>
      
      {size === 'large' && (
        <button
          onClick={() => setShowUpload(!showUpload)}
          className="absolute -bottom-1 -right-1 w-7 h-7 rounded-full bg-cyan-500 hover:bg-cyan-400 text-white shadow-lg transition-colors flex items-center justify-center"
          title={t('personalLogoUploadTooltip')}
        >
          <Upload className="w-3.5 h-3.5" />
        </button>
      )}

      {showUpload && (
        <div className="absolute top-full mt-2 left-0 sm:left-auto sm:right-0 z-50 bg-slate-900 border border-slate-700 rounded-lg p-3 shadow-xl w-48 max-w-[calc(100vw-2rem)]">
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs font-semibold text-white">{t('personalLogoUploadTitle')}</span>
            <button onClick={() => setShowUpload(false)} className="text-slate-400 hover:text-white">
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="text-xs text-slate-400 file:mr-2 file:py-1 file:px-2 file:rounded file:border-0 file:text-xs file:bg-cyan-500 file:text-white hover:file:bg-cyan-400 file:cursor-pointer"
          />
          {customLogo && (
            <button
              onClick={handleRemove}
              className="mt-2 w-full py-1 text-xs bg-slate-800 hover:bg-slate-700 text-slate-300 rounded transition-colors"
            >
              {t('personalLogoReset')}
            </button>
          )}
          <p className="text-[10px] text-slate-500 mt-2">{t('personalLogoVisibleOnly')}</p>
        </div>
      )}
    </div>
  );
};
